import {
  action,
  observable,
  makeObservable,
  makeAutoObservable,
  runInAction,
  autorun,
  toJS,
} from 'mobx'
import { ViewForm } from '../../../../services/api'
import { message } from 'antd'
import { produce } from 'immer'
import { observer } from 'mobx-react-lite'
import { getUser, getUsernameUser } from '../../../../utils/sessionManagement'
import { useParams } from 'react-router-dom'
import { nanoid } from 'nanoid'
import { useMemo, useRef, useEffect } from 'react'
import React from 'react'

class DesignerBuilderStore {
  constructor(url_code) {
    makeAutoObservable(this)
    this.url_code = url_code
  }
}

const DesignerBuilderContext = React.createContext()

const DesignerBuilderProvider = observer(({ children }) => {
  const { url_code } = useParams()
  const store = useMemo(() => new DesignerBuilderStore(url_code), [url_code])
  return (
    <DesignerBuilderContext.Provider value={store}>
      {children}
    </DesignerBuilderContext.Provider>
  )
})

export { DesignerBuilderContext, DesignerBuilderProvider }
